import {
  COMPLIANCE_ADD_REQUEST,
  COMPLIANCE_ADD_REQUEST_FAILURE,
  COMPLIANCE_ADD_REQUEST_SUCCESS,
  COMPLIANCE_CLEAN_REQUEST,
  COMPLIANCE_FETCH_REQUEST,
  COMPLIANCE_FETCH_REQUEST_FAILURE,
  COMPLIANCE_FETCH_REQUEST_SUCCESS,
  COMPLIANCE_UPDATE_REQUEST,
  COMPLIANCE_UPDATE_REQUEST_FAILURE,
  COMPLIANCE_UPDATE_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const complianceReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case COMPLIANCE_ADD_REQUEST:
    case COMPLIANCE_UPDATE_REQUEST:
    case COMPLIANCE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case COMPLIANCE_ADD_REQUEST_SUCCESS:
    case COMPLIANCE_UPDATE_REQUEST_SUCCESS:
    case COMPLIANCE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case COMPLIANCE_ADD_REQUEST_FAILURE:
    case COMPLIANCE_UPDATE_REQUEST_FAILURE:
    case COMPLIANCE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
          showSizeChanger: true,
        },
      });

    case COMPLIANCE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
          showSizeChanger: true,
        },
      });

    default:
      return state;
  }
};

export default complianceReducer;
